/* env browser */

/**
 * Executes a given entry with a given command queue instance
 *
 * @param {CommandQueue} instance - Current command queue instance
 * @param {Array} entry - Entry to be execute
 * @return {Promise<Undefined>} Void
 */
const execute = (instance, entry) => new Promise((resolve) => {
  // eslint-disable-next-line no-param-reassign
  instance.pending = true;
  const command = Array.from(entry);
  const args = command.slice(1, command.length);
  const method = command[0];
  // Check when method is init and initialize a new sensor instance
  if (method === 'init') {
    // eslint-disable-next-line no-param-reassign
    instance.sensor = instance.createSensor();
  }
  if (instance.sensor && method in instance.sensor) {
    instance.sensor[method]
      .call(instance.sensor, ...args)
      .then(() => {
        resolve();
      });
  } else {
    resolve();
  }
});
/**
 * Simple queue data structure
 * @private
 */
export class Queue {
  /**
   * Initiates a new queue data structure with data
   *
   * @param {Array} data - data to add the queue
   */
  constructor(data) {
    this.data = [];
    for (let i = 0, iLen = data.length; i < iLen; i += 1) {
      this.add(data[i]);
    }
  }

  /**
   * Adds a value at the start of the queue
   *
   * @param value
   */
  add(value) {
    this.data.push(value);
  }

  /**
   *
   * @return {*}
   */
  remove() {
    return this.data.shift();
  }

  /**
   * Clears the queue
   */
  clear() {
    this.data = [];
  }

  /**
   * Gets the size of the current queue
   * @return {*}
   */
  size() {
    return this.data.length;
  }
}

/**
 * Command queue class
 * @public
 */
export default class CommandQueue {
  /**
   *
   * @param {Array} data
   * @param {Function} createSensor
   */
  constructor(data, createSensor) {
    this.queue = new Queue(data || []);
    this.createSensor = createSensor;
    this.sensor = undefined;
    this.pending = false;
  }

  /**
   * Removes all entries from the queue
   */
  dequeue() {
    if (this.queue.size() > 0) {
      const entry = this.queue.remove();
      return execute(this, entry)
        .then(() => this.dequeue());
    }
    this.pending = false;
    return Promise.resolve();
  }

  /**
   * Pushes a value to the queue
   */
  push(...entry) {
    if (entry.length === 1 && typeof entry[0] !== 'string') {
      this.queue.add(entry[0]);
    } else {
      this.queue.add(entry);
    }
    if (this.pending === false) {
      return this.dequeue();
    }
    return Promise.resolve();
  }
}
